import Base from "../base";

/** LLMパラメータ */
export interface LlmParameter {
  /** モデル名 */
  model: string;
  /** temperature(0.0〜2.0) */
  temperature: string;
  /** top_p(0.0〜1.0) */
  top_p: string;
  /** frequency_penalty(-2.0〜2.0) */
  frequency_penalty: string;
  /** presence_penalty(-2.0〜2.0) */
  presence_penalty: string;
}

export const DefaultLlmParameter = (): LlmParameter => ({
  model: "",
  temperature: "0.5",
  top_p: "1.0",
  frequency_penalty: "0.0",
  presence_penalty: "0.0",
});

/** プロンプトテンプレート */
export interface PromptTemplate extends Base {
  /** ID */
  id: number;
  /** テンプレート種類 0:未選択(その他) 1:本誌 2:別添 */
  type: number;
  /** テンプレート名 */
  name: string;
  /** コメント */
  comment: string;
  /** データセットID */
  dataset_id: number;
  /** LLMサービス種類 1:OpenAI */
  llm_type: number;
  /** LLMサービス毎の設定情報(JSON) */
  llm_setting: string;
  /** 最終更新者ID */
  editor_admin_id: number;
  /** システムプロンプト利用 0:利用しない 1:利用する */
  use_system_message: number;
  /** システムプロンプト */
  system_message: string;
  /** プロンプトテンプレートブロック情報 */
  blocks: PromptTemplateBlock[];
  /** LLMパラメータ */
  llm_parameter: LlmParameter;
}

export const DefaultPromptTemplate = (): PromptTemplate => ({
  id: 0,
  type: 0,
  name: "",
  comment: "",
  dataset_id: 0,
  llm_type: 0,
  llm_setting: "",
  editor_admin_id: 0,
  use_system_message: 0,
  system_message: "",
  blocks: [],
  created_at: "",
  updated_at: "",
  deleted_at: "",
  llm_parameter: DefaultLlmParameter(),
});

/** プロンプトテンプレートブロック */
export interface PromptTemplateBlock extends Base {
  /** ID */
  id: number;
  /** プロンプトテンプレートID */
  prompt_template_id: number;
  /** テキスト情報 */
  text: string;
  /** 編集可能ブロックフラグ */
  is_editable_block: number;
  /** データセット挿入ブロックフラグ */
  is_dataset_block: number;
}
